// 色
export const colorOptions: { name: string }[] = [
  { name: "モノクロ" },
  { name: "4色カラー" },
];
